import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MasikKarVasuliPrint = () => {
    const location = useLocation();
    const { month, grampanchayatName } = location.state || {};

    useEffect(() => {
        setTimeout(() => {
            window.print();
        }, 500);
    }, []);

    return (
        <div className="bg-white min-h-screen p-8 text-black font-serif text-sm">
            <div className="text-center mb-6">
                <h1 className="text-xl font-bold mb-2">
                    ग्रामपंचायत {grampanchayatName || 'इनाम धामणी'} तालुका मिरज जिल्हा सांगली
                </h1>
                <h2 className="text-lg font-bold mb-1">
                    ग्रामपंचायत करवसुली अहवाल
                </h2>
                <h3 className="text-md font-bold">
                    महिना :- {month || 'ऑगस्ट'}
                </h3>
            </div>

            <div className="w-full mx-auto">
                <table className="w-full border-collapse border border-black text-center">
                    <thead>
                        {/* Main Headers */}
                        <tr>
                            <th rowSpan="2" className="border border-black px-2 py-1 w-1/6">कराचा प्रकार</th>
                            <th colSpan="3" className="border border-black px-2 py-1">चालू वर्षाची मागणी</th>
                            <th colSpan="3" className="border border-black px-2 py-1">अहवाल महिन्यापुर्वीची वसुली</th>
                            <th colSpan="3" className="border border-black px-2 py-1">अहवाल महिना वसुली</th>
                            <th colSpan="3" className="border border-black px-2 py-1">एकुण वसुली</th>
                        </tr>
                        {/* Sub Headers */}
                        <tr>
                            {/* Demand */}
                            <th className="border border-black px-2 py-1">मागील</th>
                            <th className="border border-black px-2 py-1">चालू</th>
                            <th className="border border-black px-2 py-1">एकुण</th>
                            
                            {/* Recovery Before Month */}
                            <th className="border border-black px-2 py-1">मागील</th>
                            <th className="border border-black px-2 py-1">चालू</th>
                            <th className="border border-black px-2 py-1">एकुण</th>

                            {/* Recovery During Month */}
                            <th className="border border-black px-2 py-1">मागील</th>
                            <th className="border border-black px-2 py-1">चालू</th>
                            <th className="border border-black px-2 py-1">एकुण</th>

                            {/* Total Recovery */}
                            <th className="border border-black px-2 py-1">मागील</th>
                            <th className="border border-black px-2 py-1">चालू</th>
                            <th className="border border-black px-2 py-1">एकुण</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Data Rows */}
                        <tr>
                            <td className="border border-black px-2 py-2 text-left">पाणीपट्टी</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                        </tr>
                        <tr>
                            <td className="border border-black px-2 py-2 text-left">खास पाणीपट्टी</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                        </tr>
                        {/* Total Row */}
                        <tr className="font-bold bg-gray-100 print:bg-transparent">
                            <td className="border border-black px-2 py-2"></td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                            <td className="border border-black px-2 py-2">0</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Footer Section */}
            <div className="mt-8 space-y-6">
                <div>
                    <p className="mb-2 font-bold">विहीत उद्दीष्टांपेक्षा वसुली साध्य कमी झाले असल्यास त्याची कारणे</p>
                    <div className="border-b border-black w-full h-8 mb-2"></div>
                    <div className="border-b border-black w-full h-8 mb-2"></div>
                    <div className="border-b border-black w-full h-8"></div>
                </div>

                <div className="mt-8">
                    <p className="font-bold">प्रत : मे. गटविकास अधिकारी साहेब पंचायत समिती</p>
                    <p className="font-bold">यांचेकडे माहितीसाठी सादर ता.</p>
                </div>

                <div className="flex justify-end mt-16 px-8">
                    <div className="text-center">
                        <div className="border-t border-black w-64 mt-8"></div>
                        <p className="font-bold mt-2">ग्रामपंचायत अधिकारी</p>
                    </div>
                </div>
            </div>

            <style>
                {`
                    @media print {
                        @page {
                            margin: 1cm;
                            size: landscape;
                        }
                        body {
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default MasikKarVasuliPrint;
